import * as Backbone from "backbone";
import * as _ from "lodash";
import { BaseCollection } from "./_BaseCollection";

export class ModuleLayoutCollection extends BaseCollection<Backbone.Model>{

    currentInstallId: Number;
    isForWidget: boolean = false;

    constructor(initialModels: Object[] | any[], installId: Number) {
        super();
        this.currentInstallId = installId;
        var initial = initialModels;
        this.isForWidget = (initial.length > 0) ? initial[0].isForWidget : false
    }

    url = () => {
        if (!this.isForWidget) {
            return window.location.origin + '/api/v1/installs/' + this.currentInstallId + '/layout/';            
        } else {
            return window.location.origin + '/api/v1/installs/' + this.currentInstallId + '/layoutWidget/';   
        }
    };

} 


// WEBPACK FOOTER //
// ./srv/public/js/collections/ModuleLayout.ts